import React from 'react'

const HourGlassIcon: React.FC = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.0117188" y="0.300903" width="21.3964" height="21.3964" rx="10.6982" fill="#FF9933" />
            <path d="M13.7727 6.61926V7.93287C13.7727 9.62566 12.4004 10.9979 10.7077 10.9979M10.7077 10.9979C9.01486 10.9979 7.64258 9.62566 7.64258 7.93287V6.61926M10.7077 10.9979C12.4004 10.9979 13.7727 12.3702 13.7727 14.063V15.3766M10.7077 10.9979C9.01486 10.9979 7.64258 12.3702 7.64258 14.063V15.3766" stroke="white" stroke-width="0.656801" />
            <path d="M7.20508 6.61926H14.211M14.211 15.3766H7.20508" stroke="white" stroke-width="0.656801" stroke-linecap="round" />
        </svg>
    )
}

export default HourGlassIcon;